import React from 'react'
import Header from './Header'
import Slider from './Slider'
import Services from './Services'
import BelowService from './BelowService'
import SpecialPrograms from './SpecialPrograms'

const LandingPage = () => {
  return (
    <div>
        <Header/>
        <Slider/>
        <Services/>
        <BelowService/>
        <SpecialPrograms/>
    </div>
  )
}

export default LandingPage